"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var LayoutComponents_1 = require("../../style/LayoutComponents");
var VizPortalStyles_1 = require("../../style/VizPortalStyles");
exports.centeredStyle = {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};
var CenteredMessageContainer = LayoutComponents_1.divWithStyle('CenteredMessageContainer', __assign(__assign(__assign({}, VizPortalStyles_1.vizPortalFontStyle), exports.centeredStyle), { fontSize: widgets_1.TabStyles.Typography.Sizing.XLarge, color: widgets_1.TabStyles.Colors.L8, textAlign: 'center' }));
function CenteredMessage(props) {
    return (React.createElement(CenteredMessageContainer, null, props.message));
}
exports.CenteredMessage = CenteredMessage;
//# sourceMappingURL=CenteredMessage.js.map